import { FC } from 'react';

import Skeleton from 'react-loading-skeleton';

import { useMIDs } from '@entities/mid';
import ErrorMessage from '@shared/components/ErrorMessage';
import { ISelectMultiOptions, SelectMulti } from '@shared/components/Form';

import { getMIDName } from '../utils/getMIDName';

import 'react-loading-skeleton/dist/skeleton.css';

interface IProps {
  merchantIds?: string[];
  onChangeMids?: (selectedMidsOptions: ISelectMultiOptions) => void;
}

export const MIDsMultiSelect: FC<IProps> = ({ merchantIds, onChangeMids }) => {
  const { mids, isLoading, isFetching, error } = useMIDs({ merchantIds, disableUrlFilter: true });

  if (isLoading) return <Skeleton height={42} />;
  if (error) {
    return (
      <>
        <select></select>
        <ErrorMessage error={error} />
      </>
    );
  }

  if (mids) {
    const midOptions = mids.data.map(mid => ({
      value: mid.id,
      label: getMIDName(mid),
    }));

    return (
      <SelectMulti
        name='mid_id'
        options={midOptions}
        onChange={onChangeMids}
        isDisabled={isFetching}
      />
    );
  }

  return null;
};
